import './app';
import { APP_VERSION } from './utils/globals';
console.log("%cApp version:", "font-weight: bold", APP_VERSION);
// if ('serviceWorker' in navigator) {
//   // Use the window load event to keep the page load performant
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('./service-worker.js');
//     console.log('SW registered!')
//   });
// }
